/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */

import React from 'react';
import {CustomCardGrid} from "../../../../../components/CustomCardGrid";
import {statusBorderColor, statusColor, statusFontColor} from "../../../../../enums/statusColorEnum";
import {status} from "../../../../../enums/statusEnum";
import {useTranslation} from "react-i18next";
import VehicleFieldsResume from "../../../../Dashboard/Company/Vehicles/subComponents/VehicleFieldsResume";
import vehicleDefault from '../../../../../assets/IconsTittles/ic-vehicle.svg';

const VehicleDetailsCard = (props) => {
    const { elementDetails}  = props;
    const { t } = useTranslation();

    return (
        <>
            <CustomCardGrid
                classNamePanelGrid=''
                height='border-full-shades-200 border-radius-16px'
                itemId={elementDetails?.vehicle?.id}
                statusName={t(status[elementDetails?.vehicle?.status?.id])}
                fontColor={statusFontColor[elementDetails?.vehicle?.status?.id]}
                borderColor={statusBorderColor[elementDetails?.vehicle?.status?.id]}
                statusColor={statusColor[elementDetails?.vehicle?.status?.id]}
                chipVariant={'large'}
                isSquareImg={false}
                isCheckboxShow={false}
                headClass={'minh-144px'}
                srcImage={elementDetails?.vehicle?.image ? `data:image/png;base64,${elementDetails?.vehicle?.image}` : vehicleDefault}
                backgroundImage={
                    elementDetails?.vehicle?.image != null ? `data:image/png;base64,${elementDetails?.vehicle?.image}` : ''
                }
            >
                <div className="px-2">
                    <VehicleFieldsResume vehicle={elementDetails?.vehicle}/>
                </div>
            </CustomCardGrid>
        </>
    );
};

export default VehicleDetailsCard;
